import type { SignInController } from "../SignInController";
import type { SignInBlockedStepController } from "./SignInBlockedStepController";

export function useSignInBlockedStep(signInController: SignInController, blockedStepController: SignInBlockedStepController) {
  const isBlockedStep = computed(() => signInController.isBlockedStep);
  const goToBlockedStep = signInController.goToBlockedStep.bind(signInController);

  return {
    isBlockedStep,
    goToBlockedStep,
  };
}